// extracted by mini-css-extract-plugin
export default {"banner":"BottomBanner_banner__an1QX","bannerHeading":"BottomBanner_bannerHeading__xFLLd","bannerText":"BottomBanner_bannerText__8QUSu","bannerLink":"BottomBanner_bannerLink__0ZlrI"};